import React, { useEffect, useState } from "react";
import { ax_analytics_fetchAnalytics } from "../api/analytics.js";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
      labels: {
        color: "#4B5563",
        usePointStyle: true, // If true, makes the legend point a circle

        font: {
          size: 14,
        },
      },
    },
    tooltip: {
      backgroundColor: "#000",
      titleColor: "#fff",
      bodyColor: "#fff",
      callbacks: {
        label: function (tooltipItem) {
          return ` ${tooltipItem.raw} Approval`;
        },
      },
    },
  },
  scales: {
    x: {
      ticks: {
        color: "#6B7280",
      },
    },
    y: {
      beginAtZero: true,
      ticks: {
        color: "#6B7280",
      },
    },
  },
};

const data = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  datasets: [
    {
      label: "Wow No.",
      data: [10, 50, 100, 70, 120, 150, 180, 200, 170, 150, 130, 100],
      borderColor: "#8B5CF6",
      backgroundColor: "rgba(139, 92, 246, 0.2)",
      fill: true,
      borderWidth: 2, // Border thickness
      tension: 0.4, // Curved design for the line
      pointRadius: 2, // Circle size
      pointBorderWidth: 1, // Circle border thickness
    },
    {
      label: "Frame No.",
      data: [20, 60, 110, 90, 140, 180, 200, 220, 200, 180, 160, 140],
      borderColor: "#3B82F6",
      backgroundColor: "rgba(59, 130, 246, 0.2)",
      fill: true,
      borderWidth: 2, // Border thickness
      tension: 0.4, // Curved design for the line
      pointRadius: 2, // Circle size
      pointBorderWidth: 1, // Circle border thickness
    },
  ],
};

const AnalyticsGraph = () => {
  const [analyticsData, setAnalyticsData] = useState({
    approved: 0,
  });

  const fetchAnalyticsData = async () => {
    const res = await ax_analytics_fetchAnalytics();
    // const { data } = await ax_analytics_fetchAnalytics();
    // const { code, success, data, description } =
    //   await ax_analytics_fetchAnalytics();
    if (res?.data) {
      setAnalyticsData({
        approved: res?.data?.Approved,
      });
      console.log("if pass");
    }
    // else {
    //   console.log("else pass");
    // }
    console.log("fetchAnalyticsData");
    // console.log("fetchAnalyticsData", JSON.stringify(res?.data));
    // const { code, success, description, data } =
    //   await ax_analytics_fetchAnalytics();

    // console.log(
    //   "ax_res_analytics - ",
    //   JSON.stringify(code + success, description, data)
    // );
    // console.log("ax_res_analytics - ", code, success, data, description);
  };

  useEffect(() => {
    fetchAnalyticsData();
  }, []);
  return (
    // <div className="bg-gray-100 min-h-screen p-8">
    <div className="h-full bg-white shadow-md rounded-lg p-4 ">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-lg lg:text-2xl font-bold text-gray-700">
          Total Approval
        </h2>
        {/* <div className="relative">
          <input
            type="text"
            value="Jan 2024 - Dec 2024"
            readOnly
            className="border rounded px-3 py-1 text-sm bg-white cursor-pointer shadow-sm"
          />
        </div> */}
      </div>

      <div className="flex items-center mb-2">
        <h3 className="text-3xl font-bold text-gray-800 mr-4">
          {analyticsData?.approved}
        </h3>
        <span className="bg-green-100 text-green-600 text-sm px-3 py-1 rounded-full">
          Approval
        </span>
      </div>

      <Line options={options} data={data} className="h-64" />
    </div>
    // </div>
  );
};

export default AnalyticsGraph;
